/**
 *
 * @author Aleynikov Boris <aleynikov.boris@gmail.com>.
 */

'use strict';

/*eslint max-len:0*/

var Emitter = require('cjs-emitter'),
    timeShift = window.timeShift || window.top.timeShift || {},
    INITED = false,
    ts = {
        enable: false,
        icon: true,
        delay: 0,
        cyclic: false,
        onExit: 0,
        length: 3600,
        path: null
    },
    plugin  = new Emitter();

function getDevices () {
    var data;

    try {
        data = JSON.parse(gSTB.GetStorageInfo('{}')); // eslint-disable-line
        data = data.result;
        data = data.map(function ( device ) {
            return {
                name: device.vendor + device.model,
                value: device.mountPath
            };
        });
    } catch ( error ) {
        data = [];
    }

    return data;
}

//  *  Code | Description
//  * ------|-------------
//  *  1    | Start playing.
//  *  2    | Stop playing.
//  *  3    | timeShiftSlidingMode:true, when playback was in timeshift mode on pause and current position differs from realtime position more that on maximum buffer duration of timeshift. If in pause mode event 3 appeared, then it is necessary to send resume.
//  *  4    | When timeshift buffer is full. After this event in timeShiftSlidingMode:false mode, new data are lost and navigation is available only in buffer or switch to real time mode (saving with resume is impossible). Event 4 while timeShiftSlidingMode:true means that timeshift buffer is full and old data will start to erase itself.
//  *  5    | Comes before 1 minute before buffer turns full (1 minute before event 4).
//  *  6    | Comes while playback if storage device is not available (data=1) or there is no free space (data=2). After this event playback will automaticly switch in real time.
//  *
function timeShiftEventHandler ( code, data ) {
    var eventName;

    switch ( code ) {
        case 1:
            plugin.emit('start');
            break;
        case 2:
            plugin.emit('stop');
            break;
        case 3:
            plugin.emit('buffer:pause:full');
            break;
        case 4:
            plugin.emit('buffer:full');
            break;
        case 5:
            plugin.emit('buffer:almost:full');
            break;
        case 6:
            if ( data === 1 ) {
                eventName = 'storage:unavailable';
            } else if ( data === 2 ) {
                eventName = 'storage:full';
            }
            plugin.emit(eventName);
            break;
    }
}


function init ( app ) {
    var delay  = app.storage.getItem('timeShiftDelay'),
        length = app.storage.getItem('timeShiftLength'),
        onExit = app.storage.getItem('timeShiftOnExitHandler'),
        cyclic = app.storage.getItem('timeShiftBufferCyclicMode'),
        enable = app.storage.getItem('timeShiftEnable'),
        deviceList;


    if ( delay ) {
        plugin.delay = delay;
    }

    if ( onExit === undefined ) {
        plugin.onExit = plugin.EXIT_NOT_SAVE;
    } else {
        plugin.onExit = onExit;
    }

    plugin.cyclic = cyclic;

    ts.icon = app.storage.getItem('timeShiftIconDisplay');

    if ( enable ) {
        ts.enable = enable;
    }

    plugin.enable = ts.enable;

    deviceList = getDevices();
    console.log(deviceList.length + ' :::');
    if ( deviceList.length ) {
        plugin.path = deviceList[0].value + '/' + plugin.SAVE_FOLDER_NAME;
    }

    window.stbEvent.addListener('message', function ( evt ) {
        var devices = [];


        if ( evt.broadcast ) {
            if ( evt.message === 'storage.mount' ) {
                devices = getDevices();

                if ( devices.length ) {
                    plugin.path = devices[0].value + '/' + plugin.SAVE_FOLDER_NAME;
                }
            }
        }
    });

    // if ( path )   plugin.path = path;
    plugin.length = length || 3600;


    window.stbEvent.addListener('media', function ( event ) {
        if ( event.code === 36 && event.info && event.info.ident === 'TimeShift' ) {
            // {"event_code":6,"ident":"TimeShift","event_data":"1"}
            timeShiftEventHandler(event.info.event_code, event.info.event_data);
            console.log('TS EVENT:' + JSON.stringify(event.info));
        }
    });

    if ( window.top.MODE_PORTAL ) {
        plugin.ALLOW_MANUAL = true;
    }

    INITED = true;
}


Object.defineProperties(plugin, {
    /**
     * Enable state of ts
     */
    enable: {
        set: function ( value ) {
            ts.enable = !!value;
            plugin.emit('change', 'enable', ts.enable);
        },
        get: function () { return ts.enable; }
    },
    /**
     * On timeShift exit handler
     */
    onExit: {
        set: function ( val ) {
            ts.onExit = val;
            plugin.emit('change', 'onExit', ts.onExit);
        },
        get: function () { return ts.onExit; }
    },
    delay: {
        set: function ( val ) {
            ts.delay = val;
            plugin.emit('change', 'delay', ts.delay);
        },
        get: function () { return ts.delay; }
    },
    displayIcon: {
        get: function (  ) {
            return ts.icon;
        },
        set: function ( value ) {
            value = !!value;
            ts.icon = value;
            plugin.emit('change', 'displayIcon', ts.icon);
        }
    },
    cyclic: {
        set: function ( val ) {
            ts.cyclic = !!val;
            timeShift.SetSlidingMode(ts.cyclic); // eslint-disable-line
            plugin.emit('change', 'cyclic', ts.cyclic);
        },
        get: function () { return ts.cyclic; }
    },
    length: {
        set: function ( val ) {
            timeShift.SetMaxDuration(val); // eslint-disable-line
            console.log('timeShift.SetMaxDuration ' + val);
            ts.length = val;
            plugin.emit('change', 'length', ts.length);
        },
        get: function () { return ts.length; }
    },
    path: {
        set: function ( path ) {
            timeShift.SetTimeShiftFolder(path); // eslint-disable-line
            ts.path = path;
            console.log('TIME SHIFT SET PATH:' + path);
        },
        get: function () { return ts.path; }
    },
    mountUsb: {
        get: function () {
            var mount = false;

            if ( ts.path ) {
                mount = ts.path.replace('/' + plugin.SAVE_FOLDER_NAME, '');
            }

            return mount;
        }
    }
});

plugin.EXIT_NOT_SAVE = 0;

plugin.EXIT_SAVE = 1;

plugin.EXIT_REQUEST_SAVE = 2;

plugin.SAVE_FOLDER_NAME = 'records';


plugin.setSlidingMode = function ( enableMode ) {
    timeShift.SetSlidingMode(enableMode); // eslint-disable-line
};

plugin.checkAbility = function ( config ) {
    var state = false;

    config = config || {};

    if ( /rtp\:|udp\:/.test(config.uri) || /ffrt\s/.test(config.uri) || config.solution === 'ffrt' ) { // eslint-disable-line
        state = true;
    }

    return state;
};

plugin.enter = function () {
    return top.timeShift.EnterTimeShift(); // eslint-disable-line
};

plugin.exit = function ( config ) {
    if ( config && config.save && config.save.path && config.save.name ) {
        return top.timeShift.ExitTimeShiftAndSave(config.save.path, config.save.name); // eslint-disable-line
    }

    return top.timeShift.ExitTimeShift(); // eslint-disable-line

};

module.exports =  function ( app ) {
    if ( !INITED ) {
        init(app);
    }

    return  plugin;
};
